import { useCallback, type FC } from 'react';
import c from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import DaDreamupLogoAndTextColoredAndBranded from '@wix/da-ds/pkg/DaDreamupLogoAndTextColoredAndBranded';
import { getIsBurgerMenuOpen } from '../../../redux/dreamup/selectors';
import { toggleBurgerMenu } from '../../../redux/dreamup/actions';
import SidebarLayout from '../../shared/sidebar/SidebarLayout';
import BurgerButton from '../../shared/BurgerButton';
import SidebarDivider from '../../shared/sidebar/SidebarDivider';
import BackToDaLinkListItem from '../../shared/sidebar/BackToDaLinkListItem';
import ExploreCreationsLinkListItem from '../../shared/sidebar/ExploreCreationsLinkListItem';
import AccountStatus from '../../shared/accountStatus/AccountStatus';
import ContactLinkListItem from '../../shared/sidebar/ContactLinkListItem';
import FaqLinkListItem from './FaqLinkListItem';
import LegalUrlsBlock from './LegalUrlsBlock';
import SellYourArtListItem from './SellYourArtListItem';
import StudioListItem from './StudioListItem';
import OldDreamupLogoBlock from './OldDreamupLogoBlock';
import VideoCreatorListItem from './VideoCreatorListItem/VideoCreatorListItem';

import s from './Sidebar.scss';

interface Props {}

const Sidebar: FC<Props> = () => {
  const isBurgerMenuOpen = useSelector(getIsBurgerMenuOpen);
  const dispatch = useDispatch();

  const handleBurgerButtonClick = useCallback(() => {
    dispatch(toggleBurgerMenu());
  }, [dispatch]);

  return (
    <SidebarLayout
      className={c(s['root'], isBurgerMenuOpen && s['open'])}
      showChildren={isBurgerMenuOpen}
      header={
        <>
          <BurgerButton
            className={s['burger']}
            onClick={handleBurgerButtonClick}
            suppressIndicator
          />
          {!isBurgerMenuOpen && (
            <DaDreamupLogoAndTextColoredAndBranded view={'light'} className={s['logo']} />
          )}
          {isBurgerMenuOpen && <BackToDaLinkListItem />}
        </>
      }
      headerClassName={s['header']}
      contentBlocks={[
        <div key="account-status" className={s['plan']}>
          <AccountStatus />
        </div>,
        <SidebarDivider key="divider-1" className={s['divider']} top={24} bottom={16} />,
        <div key="links">
          <SellYourArtListItem />
          <StudioListItem />
          <VideoCreatorListItem />
          <ExploreCreationsLinkListItem />
        </div>,
        <SidebarDivider key="divider-2" className={s['divider']} top={16} bottom={24} />,
        <FaqLinkListItem key="faq" />,
        <ContactLinkListItem key="contact" />,
        <LegalUrlsBlock className={s['legal']} key="legal" />,
      ]}
      footer={<OldDreamupLogoBlock />}
    />
  );
};

Sidebar.displayName = 'Sidebar';

export default Sidebar;
